import { createSlice } from '@reduxjs/toolkit';
// utils
import axios from '../../utils/axios';

// import { rolesPrueba } from '../../constants/roles';

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  error: false,
  roles: [],

  // este es el rol actual del usuarioP
  actualRol: {},

  listaViews: []
  // rolOlimpo: {}
};

const slice = createSlice({
  name: 'dagpacketRoles',
  initialState,
  reducers: {
    addViewToSectionAction: (state, action) => {
      const { view, idSection, idRol } = action.payload;

      const rol = state.roles.find((rol) => rol.id === idRol);
      const sect = rol.sectionViews.find((sec) => sec.id === idSection);

      sect.allowedViews.push(view);
    },

    addSectionView: (state, action) => {
      const { section, idRol } = action.payload;

      const rol = state.roles.find((rol) => rol.id === idRol);
      // const sect = rol.sectionViews.find((sec) => sec.id === idSection);

      rol.sectionViews.push(section);
    },

    getListViewAction: (state, action) => {
      const roles = action.payload;

      state.rolesOlimpo = roles;
    },

    // add all view pages
    addAllViewsPageAction: (state, action) => {
      const { idSection, idRol } = action.payload;

      const rol = state.roles.find((rol) => rol.id === idRol);
      const sect = rol.sectionViews.find((sec) => sec.id === idSection);

      sect.allowedViews.map((view) => (view.allowedPage = true));
    },

    // remove all view pages
    removeAllViewsPageAction: (state, action) => {
      const { idSection, idRol } = action.payload;

      const rol = state.roles.find((rol) => rol.id === idRol);
      const sect = rol.sectionViews.find((sec) => sec.id === idSection);

      sect.allowedViews.map((view) => (view.allowedPage = false));
    },

    // add all view
    addAllViewsAction: (state, action) => {
      const { idSection, idRol } = action.payload;

      const rol = state.roles.find((rol) => rol.id === idRol);
      const sect = rol.sectionViews.find((sec) => sec.id === idSection);

      sect.allowedViews.map((view) => (view.allowed = true));
      sect.showSectionView = true;
    },

    // remove all view
    removeAllViewsAction: (state, action) => {
      const { idSection, idRol } = action.payload;

      const rol = state.roles.find((rol) => rol.id === idRol);
      const sect = rol.sectionViews.find((sec) => sec.id === idSection);

      sect.allowedViews.map((view) => (view.allowed = false));
      sect.showSectionView = false;
    },

    // addViewPage --------------
    addViewPageAction: (state, action) => {
      const { idView, idContainer, idRol } = action.payload;

      const rol = state.roles.find((rol) => rol.id === idRol);

      const section = rol.sectionViews.find((view) => view.id === idContainer);
      const view = section.allowedViews.find((view) => view.id === idView);
      view.allowedPage = true;
    },

    // removeViewPage ----------
    removeViewPageAction: (state, action) => {
      const { idView, idContainer, idRol } = action.payload;

      const rol = state.roles.find((rol) => rol.id === idRol);

      const section = rol.sectionViews.find((view) => view.id === idContainer);
      const view = section.allowedViews.find((view) => view.id === idView);
      view.allowedPage = false;
    },

    // addView
    addViewAction: (state, action) => {
      const { idView, idContainer, idRol } = action.payload;

      const rol = state.roles.find((rol) => rol.id === idRol);

      const section = rol.sectionViews.find((view) => view.id === idContainer);
      const view = section.allowedViews.find((view) => view.id === idView);
      view.allowed = true;

      // allowedViewsTotalCount la cantidad de vistas de la seccion
      // allowedViesCount la cantidad de vistas que son permitidas de la seccion
      const allowedViewsTotalCount = section.allowedViews.length;
      const allowedViesCount = section.allowedViews.filter((item) => item.allowed === true).length;

      if (allowedViesCount === 0) {
        section.showSectionView = false;
      } else {
        section.showSectionView = true;
      }

      // if (allowedViewsTotalCount === allowedViesCount) {
      //   console.log('son iguales', allowedViewsTotalCount, allowedViesCount);
      //   section.noAllowedViews = false;
      // } else {
      //   console.log('son diferentes', allowedViewsTotalCount, allowedViesCount);
      //   section.noAllowedViews = false;
      // }
    },
    // remove view
    removeViewAction: (state, action) => {
      const { idView, idContainer, idRol } = action.payload;

      const rol = state.roles.find((rol) => rol.id === idRol);

      const section = rol.sectionViews.find((view) => view.id === idContainer);
      const view = section.allowedViews.find((view) => view.id === idView);
      view.allowed = false;

      const allowedViewsTotalCount = section.allowedViews.length;
      const allowedViesCount = section.allowedViews.filter((item) => item.allowed === true).length;

      if (allowedViesCount === 0) {
        section.showSectionView = false;
      } else {
        section.showSectionView = true;
      }

      // if (allowedViewsTotalCount === allowedViesCount) {
      //   console.log('son iguales', allowedViewsTotalCount, allowedViesCount);
      // } else {
      //   console.log('son diferentes', allowedViewsTotalCount, allowedViesCount);
      // }
    },

    // funcs

    getFirebaseActualRol: (state, action) => {
      const data = action.payload;

      state.actualRol = data;
    },

    // add roles

    getRolesAction: (state, action) => {
      const roles = action.payload;

      state.roles = roles;
    },

    // select rol by id

    // selectRolAction: (state, action) => {
    //   const rolName = action.payload;
    //   const item = state.roles.find((rol) => rol.id === rolName);

    //   state.rol = item;
    // },

    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    }
  }
});

// Reducer
export default slice.reducer;

export const {
  addViewAction,
  removeViewAction,
  getRolesAction,
  addSectionView,
  addViewToSectionAction,
  getListViewAction,
  getFirebaseActualRol,
  addViewPageAction,
  removeViewPageAction,
  addAllViewsAction,
  removeAllViewsAction,
  addAllViewsPageAction,
  removeAllViewsPageAction
} = slice.actions;

// ----------------------------------------------------------------------

// export const getFirebaseRol = (rolName) => (state, dispatch) => {
//   try {
//     firestore
//       .collection('roles')
//       .doc(rolName)
//       .onSnapshot((doc) => {
//         console.log(doc.data());
//         dispatch()
//       });
//   } catch (error) {
//     console.log(error);
//   }
// };

export function getLabels() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get('/api/mail/labels');
      dispatch(slice.actions.getLabelsSuccess(response.data.labels));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------
